import { createAction, createReducer } from 'deox';
import { PushProvisionResult } from 'utils/breadPushProvisioningSDK';
import { resetInstantCredit } from './resetInstantCredit';

export interface UnifiedIssuance {
  issuanceId: string | null;
  hasWallets: boolean | null;
  pushProvisionResult: PushProvisionResult | null;
}

const defaultState: UnifiedIssuance = {
  issuanceId: null,
  hasWallets: null,
  pushProvisionResult: null,
};

export const mergeIssuance = createAction(
  'MERGE_ISSUANCE',
  resolve => (issuance: Partial<UnifiedIssuance>) => resolve(issuance),
);

export const unifiedIssuanceReducer = createReducer(
  defaultState,
  handleAction => [
    handleAction(mergeIssuance, (state, { payload }) => ({
      ...state,
      ...payload,
    })),
    handleAction(resetInstantCredit, () => defaultState),
  ],
);

interface MountedState {
  unifiedIssuance: UnifiedIssuance;
}

export const selectUnifiedIssuance = (state: MountedState): UnifiedIssuance => {
  return state.unifiedIssuance;
};

export default unifiedIssuanceReducer;
